import { render, staticRenderFns } from "./ProfileEmailSignature.vue?vue&type=template&id=b71b8d08&"
import script from "./ProfileEmailSignature.vue?vue&type=script&lang=js&"
export * from "./ProfileEmailSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports